import React, { useEffect, useState } from "react";
import {
    Box,
    Stack,
    TextField,
    Typography,
    Button,
    IconButton,
    TableHead,
    TablePagination,
    TableCell,
    Table,
    Chip,
    TableRow,
    TableBody,
    Paper,
    TableContainer
    
} from "@mui/material";
import Container from 'react-bootstrap/Container'
import AppTableView from '../AppTableView'
import Tooltip from "@mui/material/Tooltip"
import AxiosInstance from "../../services/AxiosInstance";
import {
    Add,
    Visibility
} from "@mui/icons-material";
import CreateChangeDialog from "./CreateChangeDialog";
import { CHANGE_REQUEST_URL } from "../../Constants/Constants";
import { Link } from "react-router-dom";

const ChangeList = ({ onView }) => {

    // existing states
    // loadChanges()
    // pagination
    // etc.

    const [changes, setChanges] = useState([]);
    const [open, setOpen] =
        useState(false);

    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] =
        useState(10);

    const [total, setTotal] =
        useState(0);

    const [loading, setLoading] =
        useState(false);


    // ============================
    // CREATE CHANGE
    // ============================

    const onCreate = () => {
        setOpen(true);
    };


    const handleClose = () => {
        setOpen(false);
    };


    const handleSaved = () => {

        setOpen(false);

        loadChanges();
    };


    const formatDate = (value) => {

        if (!value) {
            return "-";
        }

        return new Date(value)
            .toLocaleString();
    };

    // ============================
    // LOAD CHANGES
    // ============================

    const loadChanges = async () => {

        setLoading(true);

        try {

            const response =
                await AxiosInstance.get(
                    CHANGE_REQUEST_URL,
                    {
                        params: {
                            page,
                            size: rowsPerPage
                        }
                    }
                );

            setChanges(
                response.data.content || []
            );

            setTotal(
                response.data.totalElements || 0
            );

        } catch (error) {

            console.error(
                "Unable to load changes",
                error
            );

        } finally {

            setLoading(false);

        }
    };


    useEffect(() => {

        loadChanges();

    }, [page, rowsPerPage]);



    return (
        <Box
            sx={{
                p: 2,
                pt: 0,
                width: "100%"
            }}
        >

            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
            >

                <Typography variant="h5">
                    Change Requests
                </Typography>

                <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={onCreate}
                >
                    Create Change
                </Button>

            </Stack>

            {/* table */}

            {/* ================= TABLE ================= */}

            <Container fluid style={{ display: "flex", flexDirection: "column" }}>
                <AppTableView
                    rows={changes}
                    initialPageSize={15}
                    cols={[
                        {
                            field: "changeNumber", 
                            headerName: "Change ID", 
                            flex: 1,
                            minWidth: 120,
                            renderCell: (params) => {
                                return (
                                    <Tooltip
                                        title={params.value || ""}                                        
                                        onClick={() =>
                                            onView(params.row.id)
                                        }
                                    >
                                        <Link>
                                        {params.value} 
                                        </Link>
                                    </Tooltip>
                                );
                            }
                        },
                        {
                            field: "title",
                            headerName: "Title",
                            flex: 1,
                            minWidth: 120,
                            sortable: false,
                            filterable: false,
                            renderCell: (params) => {
                                return <Tooltip title={params.valu}>{params.value}</Tooltip>
                            }
                        },
                        {
                            field: "changeTypeName",
                            headerName: "Type",
                            flex: 1,
                            minWidth: 100,
                            sortable: false,
                            filterable: false,
                            renderCell: (params) => {
                                return <Tooltip title={params.value}>{params.value}</Tooltip>
                            }
                        },
                        {
                            field: "categoryName",
                            headerName: "Category",
                            flex: 1,
                            minWidth: 100,
                            sortable: false,
                            filterable: false,
                            renderCell: (params) => {
                                return <Tooltip title={params.valu}>{params.value}</Tooltip>
                            }
                        },
                        {
                            field: "priorityName",
                            headerName: "Priority",
                            flex: 1,
                            minWidth: 100,
                            sortable: false,
                            filterable: false,
                            renderCell: (params) => {
                                return <Tooltip title={params.valu}>{params.value}</Tooltip>
                            }
                        },
                        {
                            field: "riskName",
                            headerName: "Risk",
                            flex: 1,
                            minWidth: 100,
                            sortable: false,
                            filterable: false,
                            renderCell: (params) => {
                                return <Tooltip title={params.valu}>{params.value}</Tooltip>
                            }
                        },
                        {
                            field: "statusName",
                            headerName: "Status",
                            flex: 1,
                            minWidth: 100,
                            renderCell: (params) => {
                                return (
                                    <Tooltip
                                        title={params.value || ""}
                                        arrow
                                    >
                                        <Chip
                                            label={params.value}
                                            size="small"
                                            sx={{
                                                backgroundColor: params.value?.color || "#9E9E9E",
                                                color: '#000000',
                                                fontWeight: 600
                                            }}
                                        /></Tooltip>

                                )
                            },
                        },
                        {
                            field: "requestedBy",
                            headerName: "Requested By",
                            flex: 2,
                            minWidth: 80,
                            renderCell: (params) => {
                                return <Tooltip title={params.value}>{params.value}</Tooltip>
                            },
                        },
                        {
                            field: "plannedStartDate",
                            headerName: "Planned Start",
                            flex: 2,
                            minWidth: 100,
                            renderCell: (params) => {
                                return <Tooltip title={formatDate(params.value)}>{formatDate(params.value)}</Tooltip>
                            },
                        },
                        {
                            field: "plannedEndDate",
                            headerName: "Planned End",
                            flex: 2,
                            minWidth: 100,
                            renderCell: (params) => {
                                return <Tooltip title={formatDate(params.value)}>{formatDate(params.value)}</Tooltip>
                            },
                        }

                    ]}
                />
            </Container>

            {/* ================= CREATE CHANGE DIALOG ================= */}

            <CreateChangeDialog
                open={open}
                onClose={handleClose}
                onSaved={handleSaved}
            />

        </Box>
    );
};

export default ChangeList;